<script setup lang="ts">
  import { MpIcon, MpLoadingContainer, useMpScreen } from '@borg/ui';
  import { DocumentInfo, MpFile } from '@borg/types';

  const props = defineProps<{
    file?: MpFile;
  }>();

  const emits = defineEmits<{
    close: [];
  }>();

  const { isMobile } = useMpScreen();

  const isOpen = ref(false);
  const documentId = ref<number>();
  const downloadAnchor = ref<HTMLAnchorElement>();

  const documentInfo = await documentInfoRepository.get(documentId);

  function isDocumentAnImage(document: DocumentInfo) {
    return ['png', 'jpeg', 'jpg'].includes(document.type);
  }

  function onOpen() {
    if (props.file) {
      documentId.value = props.file.id;
      documentInfo.execute();
    }
  }

  function onStartDownload() {
    if (downloadAnchor.value) {
      downloadAnchor.value.click();
    }
  }
</script>

<template>
  <SiteActionsModal
    :is-open="isOpen"
    :title="file?.name"
    :in-progress="false"
    :confirm-button-label="$t('DOWNLOAD')"
    :cancel-button-label="$t('CLOSE')"
    confirm-button-left-icon="download"
    :confirm-button-disabled="documentInfo.pending.value"
    :close-button="isMobile"
    content-align="center"
    @open="onOpen"
    @cancel="emits('close')"
    @confirm="onStartDownload"
  >
    <MpLoadingContainer :is-loading="documentInfo.pending.value">
      <template v-if="documentInfo.data.value">
        <img
          v-if="isDocumentAnImage(documentInfo.data.value)"
          :src="documentInfo.data.value.url"
          :alt="documentInfo.data.value.name"
          style="width: 100%; min-height: 10vh"
        />
        <MpIcon
          v-else
          icon="visibility_off"
        />
        <a
          ref="downloadAnchor"
          :href="documentInfo.data.value.url"
          :download="documentInfo.data.value.name"
          style="display: none"
          target="_blank"
        >
          {{ $t('DOWNLOAD') }}
        </a>
      </template>
    </MpLoadingContainer>
  </SiteActionsModal>
</template>
